/**
 * 首页 / 报告新旧版 UI
 * 已统一进入新版；旧版路由与页面保留，仅关闭切换入口。
 * localStorage.uiVersion 字段暂保留，兼容历史数据，不再作为生效依据。
 */

export const UI_VERSION_KEY = 'uiVersion'
export const UI_VERSION_NEW = 'new'
export const UI_VERSION_OLD = 'old'

/**
 * 是否新版 UI（固定为新版）
 * @returns {boolean}
 */
export function isNewUiVersion() {
  return true
}

/**
 * 读取当前版本
 * @returns {'new'|'old'}
 */
export function getUiVersion() {
  return UI_VERSION_NEW
}

/**
 * 设置版本（已停用切换，保留空实现避免调用报错）
 * @param {'new'|'old'} version
 */
export function setUiVersion(version) {
  localStorage.setItem(
    UI_VERSION_KEY,
    version === UI_VERSION_NEW ? UI_VERSION_NEW : UI_VERSION_OLD
  )
}

/**
 * 新版首页路由名
 * @returns {string}
 */
export function getHomeRouteName() {
  return isNewUiVersion() ? 'healthAiHome' : 'healthHomePage'
}

/**
 * 底部第二 Tab 路由名
 * - 新版：监测看板 healthMonitoringDashboard
 * - 旧版：报告 healthReport
 * @returns {string}
 */
export function getReportRouteName() {
  return isNewUiVersion() ? 'healthMonitoringDashboard' : 'healthReport'
}

/**
 * 新版「健康」入口：日报周报总览
 * @returns {string}
 */
export function getHealthReportShowcaseRouteName() {
  return 'healthReportShowcase'
}



// WEBPACK FOOTER //
// ./src/utils/uiVersion.js